import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-up', 'ChevronUp', [["path",{"d":"m18 15-6-6-6 6","key":"svg-0"}]]);